// ======================================================================
// File Name       : BoxRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form, InputGroup, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as boxActions from '../../actions/BoxAction';
import * as containerActions from '../../actions/ContainerAction';
import * as ModalAction from '../../actions/ModalAction';
import { postContainerGetStructureByCourseSecernId } from '../../actions/httpRequests/course';
import { Category } from '../../components/Detail';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../../components/FormControlValidate';
import SelectBox from '../../components/SelectBox';
import TableHead from '../../components/TableHead';
import { FormControl, Radio } from '../../components/formControl';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { MODE, VALIDATE_TYPE } from '../../constants';
import { CHOSEN_THUMBNAIL_BOX, END_CONDITION_TYPE_FOR_BOX, REDIRECT_MODAL } from '../../constants/BoxConstants';
import { START_CONDITION_TYPE_FOR_BOX } from '../../constants/ItemConstant';
import * as ModalIds from '../../constants/ModalIds';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import UserAttributeRegisterEditContainer from '../userAttribute/UserAttributeRegisterEditContainer';
import * as boxUtils from '../../utils/BoxUtils';

class BoxRegisterEditContainer extends Component {
  constructor() {
    super();

    this.state = {};

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOkBtn = this.handleOkBtn.bind(this);
    this.handleDetailSettingTitleClick = this.handleDetailSettingTitleClick.bind(this);
    this.handleUserAttributeTitleClick = this.handleUserAttributeTitleClick.bind(this);
    this.validation = this.validation.bind(this);
    this.handleImageFileSelectTypeChange = this.handleImageFileSelectTypeChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.clearFileUpload = this.clearFileUpload.bind(this);
  }

  handleOkBtn() {
    const { dispatch, modalId, box } = this.props;
    const { editType, editingBox } = box;
    const imageFileSelectType = editingBox.imageFileSelectType;
    if (this.validation()) {
      if (editType === MODE.EDIT_MODE) {
        dispatch(boxActions.changeData());
      }
      if (imageFileSelectType === CHOSEN_THUMBNAIL_BOX.DEFAULT) {
        dispatch(boxActions.getDefaultThumbnail());
      }
      dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].OK));
    }
  }

  handleFileChange(event) {
    try {
      if (event.target.files && event.target.files.length !== 0) {
        const reader = new FileReader();
        const imageUploadFileName = event.target.files[0].name;
        const imageUploadFile = event.target.files[0];
        const { dispatch } = this.props;
        dispatch(boxActions.handleInputChange({ imageUploadFile }));
        reader.readAsDataURL(imageUploadFile);
        reader.onload = () => {
          const dataUrl = reader.result;
          dispatch(boxActions.handleInputChange({ dataUrl }));
        };
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleImageFileSelectTypeChange(name, value) {
    const { dispatch, box } = this.props;
    const imageFileSelectType = box.editingBox.imageFileSelectType;
    dispatch(boxActions.handleInputChange({ [name]: value }));
    if (imageFileSelectType === CHOSEN_THUMBNAIL_BOX.MANUAL || imageFileSelectType === CHOSEN_THUMBNAIL_BOX.NOTHING) {
      this.clearFileUpload();
    }
  }

  handleInputChange(name, value) {
    const { dispatch } = this.props;
/*    const { listItemsOfBox } = this.state;
    if (name == 'endConditionTypeForBox') {
      const { box } = this.props;
      const { childItemSercernIdList } = box;
      this.setState({ listItemsOfBox: childItemSercernIdList || [] });
    }*/

    if (name === 'startConditionTypeForBox' && value !== START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION) {
      dispatch(boxActions.handleInputChange({ progressRatioForBoxStart: 0 }));
    }
    dispatch(boxActions.handleInputChange({ [name]: value }));
  }

  handleDetailSettingTitleClick() {
    const { dispatch, box: { detailSettingExpanded } } = this.props;
    dispatch(boxActions.saveDetailSettingState('detailSettingExpanded', !detailSettingExpanded));
  }

  handleUserAttributeTitleClick() {
    const { dispatch, box: { userAttributeExpanded } } = this.props;
    dispatch(boxActions.saveDetailSettingState('userAttributeExpanded', !userAttributeExpanded));
  }

  getModalOptions() {
    return {
      title: '登録/変更内容を入力してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        { name: 'OK', onClick: this.handleOkBtn, variant: 'primary' },
      ],
    };
  }

  clearFileUpload() {
    const imageUploadFileName = null;
    if (this.fileInput && this.fileInput.clearInput) {
      this.fileInput.clearInput();
    }
    const { dispatch } = this.props;
    dispatch(boxActions.handleInputChange({ imageUploadFile: null }));
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  // sprint_20230522_tma START
  handleAddBtnClick() {
    const { dispatch, container: { rootCourseSecernId } } = this.props;

    postContainerGetStructureByCourseSecernId(rootCourseSecernId).then((res) => {
      dispatch(containerActions.getDataItemTree(res));
      dispatch(ModalAction.openModal(ModalIds.ITEM_TREE_CONTAINER));
    });
  }

  removeItemInDialog(index) {
    const { dispatch } = this.props;
    dispatch(containerActions.removeItemListRelation(index));
  }
  // sprint_20230522_tma END

  render() {
    const { editType, editingBox, childItemSercernIdList, detailSettingExpanded, userAttributeExpanded } = this.props.box;
    const {
      boxName,
      description,
      publicStatus,
      endConditionTypeForBox,
      limitPublicPeriod,
      parentCourseSecernId,
      boxSecernId,
      imageFileSelectType,
      imageUploadFile,
      startConditionTypeForBox,
      progressRatioForBoxStart,
    } = editingBox;
    const { structures, selectedItemList } = this.props.container;
    let fileName = '';
    if (editingBox.imageUploadFile && editingBox.imageUploadFile.name) {
      fileName = editingBox.imageUploadFile.name;
    }
    let fileSize = 0;
    if (editingBox.imageUploadFile && editingBox.imageUploadFile.size) {
      fileSize = editingBox.imageUploadFile.size;
    }
    // Step 10.2.0 START
    const isEnableBoxEndCondition = boxUtils.isEnableBoxEndCondition(endConditionTypeForBox);
    const hasOldEndCondition = isEnableBoxEndCondition && endConditionTypeForBox !== END_CONDITION_TYPE_FOR_BOX.NONE;
    const listItemsOfBox = hasOldEndCondition && childItemSercernIdList && childItemSercernIdList.length ?
      childItemSercernIdList : [];
    // Step 10.2.0 END
    this.refsToValidate = [];
    const acceptTypes = 'image/*';

    const thead = [
      { title: "コース表示名称", sortBy: null },
      { title: "親セクション名", sortBy: null },
      { title: "操作", sortBy: null, width: 110 },
    ];

    let dataTable = null;
    if (selectedItemList && selectedItemList.length) {
      dataTable = selectedItemList.map((cur, index) => {
        let itemName = '';
        let boxNameWithItem = '';
        let boxIdWithItem = '';
        if (
          structures.bySecernId[cur.itemSecernId] &&
          Object.keys(structures.bySecernId).length
        ) {
          itemName = structures.bySecernId[cur.itemSecernId].structureName;
          boxIdWithItem = structures.bySecernId[cur.itemSecernId].parentBoxSecernId;
          boxNameWithItem = structures.bySecernId[boxIdWithItem].structureName;
        }
        return (
          <tr key={index}>
            <td>{itemName}</td>
            <td>{boxNameWithItem}</td>
            <td className="text-center">
              <i
                role="button"
                onClick={this.removeItemInDialog.bind(this, index)}
                className="bi bi-trash margin-top-10"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleOkBtn();
          }}
          className="form-horizontal"
        >
          <Category label="基本設定" />
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              セクション名<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={9} className="padding-right-15">
              <FormControlValidate
                name="boxName"
                type="text"
                label="セクション名"
                value={boxName || ""}
                onChange={(event) => {
                  if (event && event.target) {
                    const { name, value } = event.target;
                    this.handleInputChange(name, value);
                  }
                }}
                required
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              説明
            </Col>
            <Col sm={9} className="padding-right-15">
              <FormControl
                name="description"
                maxLength="1024"
                value={description || ""}
                onChange={this.handleInputChange}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              公開ステータス
            </Col>
            <Col sm={9} className="padding-right-15">
              <SelectBox
                data={SELECT_BOX_DATA.PUBLIC_STATUS}
                name="publicStatus"
                value={publicStatus}
                useConvertedValue
                onChange={this.handleInputChange}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              サムネイル画像
            </Col>
            <Col sm={9} className="padding-left-clear padding-top-10">
              {editType === MODE.EDIT_MODE && (
                <Col sm={4}>
                  <Radio
                    inline
                    className="padding-top-clear"
                    name="imageFileSelectType"
                    id={`imageFileSelectType-${CHOSEN_THUMBNAIL_BOX.NOTHING}`}
                    value={CHOSEN_THUMBNAIL_BOX.NOTHING}
                    checked={
                      imageFileSelectType === CHOSEN_THUMBNAIL_BOX.NOTHING
                    }
                    onChange={this.handleImageFileSelectTypeChange}
                    label="変更しない"
                  />
                </Col>
              )}
              <Col sm={4}>
                <Radio
                  inline
                  className="padding-top-clear"
                  name="imageFileSelectType"
                  id={`imageFileSelectType-${CHOSEN_THUMBNAIL_BOX.DEFAULT}`}
                  value={CHOSEN_THUMBNAIL_BOX.DEFAULT}
                  checked={imageFileSelectType === CHOSEN_THUMBNAIL_BOX.DEFAULT}
                  onChange={this.handleImageFileSelectTypeChange}
                  label={
                    editType === MODE.EDIT_MODE
                      ? "初期画像に変更"
                      : "初期画像で登録"
                  }
                />
              </Col>
              <Col sm={4}>
                <Radio
                  inline
                  className="padding-top-clear"
                  name="imageFileSelectType"
                  id={`imageFileSelectType-${CHOSEN_THUMBNAIL_BOX.MANUAL}`}
                  value={CHOSEN_THUMBNAIL_BOX.MANUAL}
                  checked={imageFileSelectType === CHOSEN_THUMBNAIL_BOX.MANUAL}
                  onChange={this.handleImageFileSelectTypeChange}
                  label="手動で画像を変更"
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group
            className={
              this.props.box.editingBox.imageFileSelectType ===
              CHOSEN_THUMBNAIL_BOX.MANUAL
                ? "margin-top-10 form-info"
                : "hidden-upload-file form-info"
            }
          >
            <Col sm={7} className="col-sm-offset-3">
              <FormControlValidate
                label="サムネイル画像"
                type="text"
                name="imageUploadFile"
                className="margin-bottom-10"
                value={fileName || ""}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required={imageFileSelectType === CHOSEN_THUMBNAIL_BOX.MANUAL}
                fileSize={fileSize}
                validateType={VALIDATE_TYPE.THUMBNAIL_SIZE_AND_TYPE}
              />
            </Col>
            <Col sm={2}>
              <FileUpload
                inputId={"upload-file-box"}
                onChange={this.handleFileChange}
                fileName={this.state.imageUploadFileName}
                labelName="選択"
                ref={(ref) => {
                  this.fileInput = ref;
                }}
                accept={acceptTypes}
              />
            </Col>
          </Form.Group>
          <Form.Group
            className={
              this.props.box.editingBox.imageFileSelectType ===
              CHOSEN_THUMBNAIL_BOX.MANUAL
                ? "margin-top-10 form-info"
                : "hidden-upload-file form-info"
            }
          >
            <Col
              sm={2}
              className="col-sm-offset-10 padding-left-15 padding-bottom-7"
            >
              <Button
                variant="danger"
                disabled={!fileName}
                className="btn-96"
                onClick={this.clearFileUpload}
              >
                {"クリア"}
              </Button>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={12} className="padding-left-5">
              <a
                role="presentation"
                className={detailSettingExpanded ? "minute" : "plus"}
                onClick={this.handleDetailSettingTitleClick}
              >
                詳細設定
              </a>
            </Col>
          </Form.Group>
          {detailSettingExpanded && (
            <>
              <Form.Group className="form-info">
                <Col sm={3} as={Form.Label}>
                  セクション開始条件
                </Col>
                <Col sm={9}>
                  <Col sm={12} className="padding-top-10">
                    <Radio
                      className="margin-left-30"
                      inline
                      name="startConditionTypeForBox"
                      id={`startConditionTypeForBox-${START_CONDITION_TYPE_FOR_BOX.NO_CONDITION}`}
                      value={START_CONDITION_TYPE_FOR_BOX.NO_CONDITION}
                      checked={
                        startConditionTypeForBox ===
                        START_CONDITION_TYPE_FOR_BOX.NO_CONDITION
                      }
                      onChange={this.handleInputChange}
                      label="なし"
                    />
                  </Col>
                  <Col sm={12} className="padding-left-right-clear">
                    <Radio
                      className="margin-left-30"
                      inline
                      name="startConditionTypeForBox"
                      id={`startConditionTypeForBox-${START_CONDITION_TYPE_FOR_BOX.AND_CONDITION}`}
                      value={START_CONDITION_TYPE_FOR_BOX.AND_CONDITION}
                      checked={
                        startConditionTypeForBox ===
                        START_CONDITION_TYPE_FOR_BOX.AND_CONDITION
                      }
                      onChange={this.handleInputChange}
                      label="指定されたコンテンツを全て完了"
                    />
                  </Col>
                  <Col sm={12} className="padding-left-right-clear">
                    <Radio
                      className="margin-left-30"
                      inline
                      name="startConditionTypeForBox"
                      id={`startConditionTypeForBox-${START_CONDITION_TYPE_FOR_BOX.OR_CONDITION}`}
                      value={START_CONDITION_TYPE_FOR_BOX.OR_CONDITION}
                      checked={
                        startConditionTypeForBox ===
                        START_CONDITION_TYPE_FOR_BOX.OR_CONDITION
                      }
                      onChange={this.handleInputChange}
                      label="指定されたコンテンツのいずれかを完了"
                    />
                  </Col>
                  <Col sm={12} className="padding-left-right-clear">
                    <Col sm={9} className="padding-left-right-clear">
                      <Radio
                        className="margin-left-30"
                        inline
                        name="startConditionTypeForBox"
                        id={`startConditionTypeForBox-${START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION}`}
                        value={
                          START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION
                        }
                        checked={
                          startConditionTypeForBox ===
                          START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION
                        }
                        onChange={this.handleInputChange}
                        label="指定されたコンテンツの完了条件達成率"
                      />
                    </Col>
                    {startConditionTypeForBox ===
                      START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION && (
                      <Col sm={3} className="padding-right-15">
                        <InputGroup size="sm">
                          <FormControl
                            name="progressRatioForBoxStart"
                            component="input"
                            type="number"
                            min={0}
                            max={100}
                            onChange={this.handleInputChange}
                            value={progressRatioForBoxStart || 0}
                          />
                          <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                      </Col>
                    )}
                  </Col>
                </Col>
                {startConditionTypeForBox !==
                  START_CONDITION_TYPE_FOR_BOX.NO_CONDITION && (
                  <>
                    <Col sm={12}>
                      <Col sm={3} className="padding-top-10 padding-left-15">
                        <Button
                          variant="primary"
                          className="btn-96"
                          onClick={this.handleAddBtnClick.bind(this)}
                        >
                          {"追加"}
                        </Button>
                      </Col>
                    </Col>
                    <Col sm={12} className="margin-top-10">
                      <FormControlValidate
                        validateType={VALIDATE_TYPE.ITEM_BOX_START}
                        value={selectedItemList || []}
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                      />
                    </Col>
                    <Col
                      sm={12}
                      className="margin-top-10 padding-left-15 padding-right-15"
                    >
                      <Table striped hover>
                        <thead>
                          <TableHead data={thead} />
                        </thead>
                        <tbody>{dataTable}</tbody>
                      </Table>
                    </Col>
                  </>
                )}
              </Form.Group>
              {hasOldEndCondition && (
                <Col
                  as={Form.Label}
                  sm={{
                    span: 9,
                    offset: 3,
                  }}
                >
                  <FormControlValidate
                    validateType={VALIDATE_TYPE.ITEM_BOX_END}
                    value={listItemsOfBox || []}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              )}
              <Form.Group className="form-info">
                <Col sm={12}>
                  <UserAttributeRegisterEditContainer
                    titleClass="padding-left-20"
                    leftClass="padding-left-45"
                    expanded={userAttributeExpanded}
                    onTitleClick={this.handleUserAttributeTitleClick}
                  />
                </Col>
              </Form.Group>
            </>
          )}
          <input type="submit" hidden />
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { box, container } = state;
  return { box, container };
};

export default connect(mapStateToProps)(BoxRegisterEditContainer);
